import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// 메뉴 목록 배열로 관리
// 클릭시 path 경로로 이동
// activePaths 배열에 포함된 경로에 있을 때, 해당 메뉴가 활성화 된 거로 간주하고 초록색으로 표시
const menuItems = [
  { name: '유저 정보', path: '/users', activePaths: ['/users', '/userdetail', '/userreport', '/usercounsel', '/userexerciserate', '/useranalyze', '/userpost', '/usercomment', '/userpremium'] },
  { name: '전체 상담 기록', path: '/counsel', activePaths: ['/counsel'] },
  { name: '운동 정보 DB', path: '/exercise', activePaths: ['/exercise', '/exercisedetail'] },
  { name: '백업 운동 정보 DB', path: '/backup/exercise', activePaths: ['/backup/exercise', '/backup/exercisedetail'] },
  { name: '설문 DB', path: '/survey', activePaths: ['/survey', '/surveydetail'] },
  { name: '백업 설문 DB', path: '/backup/survey', activePaths: ['/backup/surveydetail', '/backup/survey'] },
  { name: '커뮤니티', path: '/community', activePaths: ['/community'] },
  { name: '삭제된 커뮤니티', path: '/communityremoved', activePaths: ['/communityremoved'] },
  { name: '결제 페이지 설정', path: '/checkoutoptions', activePaths: ['/checkoutoptions'] },
  { name: '약관', path: '/terms', activePaths: ['/terms'] },
  { name: '공지사항 / 이벤트', path: '/notice', activePaths: ['/notice'] },
];

const SideBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="w-64 min-w-64 flex-shrink-0 h-screen bg-primary text-white p-6 overflow-y-auto">
      <h2 className="text-xl font-bold mb-6 cursor-pointer" onClick={() => navigate('/')}>
        Bebetherafit Admin
      </h2>
      <ul className="space-y-4">
        {menuItems.map((item) => {
          const isActive = item.activePaths.includes(location.pathname);
          return (
            <li
              key={item.name}
              className={`p-3 rounded cursor-pointer transition-colors duration-200 text-sm font-medium ${
                isActive ? 'bg-green-700' : 'hover:bg-green-600'
              }`}
              onClick={() => navigate(item.path)}
            >
              <span className="block w-full whitespace-nowrap overflow-hidden text-ellipsis">
                {item.name}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SideBar;